export const environment = {
  apiURL: 'https://carsellfastadmin.demo.xeniosblockchaingroup.com',
  appVersion: require('../../package.json').version,
  background: 'background.png',
  logo: 'logo_sm.png',
  name: 'CarsellFast Admin',
  production: false,
  sentryDSN: '',
  sentryEnvironment: '',
};
